export default __webpack_public_path__ + "static/media/EM0870.34I-22722_-15181_0.b73b4b62.jpg";